<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="TITLE">Hauerwas</p>
<p class="SUBTITLE">A (Very) Critical Introduction</p>
<p class="AUTHOR">Nicholas M. Healy</p>
<p class="COMPANY">William B. Eerdmans Publishing Company<br/>Grand Rapids, Michigan / Cambridge, U.K.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Healy_Hauerwas-2.vue?4cd0fbc0